import React from 'react';
import { Table } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import './style.css';

const { Column, HeaderCell, Cell } = Table;

export default function ModerationTable({ data = [], loading = false, columns = [],}) {
  if (!loading && data.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 px-4 bg-gray-50 rounded-lg border border-gray-200">
        <svg 
          className="w-16 h-16 text-gray-400 mb-4" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
          />
        </svg>
        <h3 className="text-lg font-medium text-gray-900 mb-1">No data available</h3>
        <p className="text-sm text-gray-500">There are no items to display at this time.</p>
      </div>
    );
  }

  return (
    <>
        <Table
          data={data}
          rowKey="id"
          headerHeight={56}
          rowHeight={50}
          loading={loading}
          className="w-full"
          autoHeight

        >
      {columns.map((col, idx) => (
        <Column
          key={idx}
          width={col.width || 150}
          flexGrow={col.flexGrow || 1}
          align={col.align || 'left'}
          resizable
        >
          <HeaderCell className="bg-white text-sm font-semibold text-gray-700">
            {col.header}
          </HeaderCell>
          <Cell className="pr-4 text-sm text-gray-600">
            {rowData => (
              <div className="flex items-center h-full py-1">
                {col.cell ? col.cell(rowData) : rowData[col.key] ?? 'N/A'}
              </div>
            )}
          </Cell>
        </Column>
      ))}
    </Table>

    </>
  );
}